import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { PHENO_CODES } from '../hooks/usePhenomenaData'

// Store pro skupinový produkt "Jevy – skupina" (/station-group/grp-jevy) — viz
// doc/plans/station-group-monthly-yearly-phenomena.md sekce 5e.
// - activeTab: 'overview' (matice počtu dní) | 'detail' (1 jev × den)
// - selectedPheno: kód jevu pro záložku Detail (ne v URL, slug produktu zůstává jen 'grp-jevy')
// Období řídí globální useMonthPeriodStore — beze změny.
export const useGroupJevyStore = create(
  persist(
    set => ({
      activeTab: 'overview',
      selectedPheno: PHENO_CODES[0],
      // labelFields („Popisek stanice") je nově globální — useStationLabelStore.
      setActiveTab: activeTab => set({ activeTab }),
      setSelectedPheno: selectedPheno => set({ selectedPheno }),
    }),
    {
      name: 'group-jevy-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
